export const blocks = [
    {
        "blockId": "1-intro",
        "text": {
            "male": [
              'La tarea que estás a punto de realizar consta de distintos bloques. Tendrás pausas entre medio para que puedas descansar, aunque la duración total de la tarea no es superior a los 25 minutos aproximadamente.',
              'El funcionamiento de todos los bloques es muy similar, pero con algunas variaciones. Por favor, presta mucha atención a las instrucciones de cada bloque. Durante los bloques, tendrás que evaluar distintos adjetivos en distintos términos. Se te pedirá que des tu opinión sobre cuanto te representan, como crees que te ven tus compañer@s respecto a esos adjetivos y como crees que un/a actor/actriz debería ser. También se te pedirá un juicio sobre la valencia (positivo, neutro, negativo) de cada adjetivo.',
              'Presta atención a las escalas que debes usar para responder, en ocasiones pueden variar (ej: a veces del 1 al 100 o a veces del -100 al 100, etc.). Tus resultados son estrictamente confidenciales, por tanto, rogamos que ofrezcas respuestas intuitivas y sinceras, no le des muchas vueltas, solo utiliza tu primera impresión para ofrecer tus opiniones.',
              '¡¡Importante!! Para asegurar que las personas que participan están contestando atentamente la tarea, hemos introducido algunos “test atencionales”. Durante la tarea, sin previo aviso, aparecerá un mensaje que te pedirá que selecciones un número en concreto entre el 1 y el 100, si no lo haces correctamente tus datos no podrán ser incluidos en el estudio. Muchas gracias por tu atención, ¡adelante!'
            ],
            "female": [
              'La tarea que estás a punto de realizar consta de distintos bloques. Tendrás pausas entre medio para que puedas descansar, aunque la duración total de la tarea no es superior a los 25 minutos aproximadamente.',
              'El funcionamiento de todos los bloques es muy similar, pero con algunas variaciones. Por favor, presta mucha atención a las instrucciones de cada bloque. Durante los bloques, tendrás que evaluar distintos adjetivos en distintos términos. Se te pedirá que des tu opinión sobre cuanto te representan, como crees que te ven tus compañer@s respecto a esos adjetivos y como crees que un/a actor/actriz debería ser. También se te pedirá un juicio sobre la valencia (positivo, neutro, negativo) de cada adjetivo.',
              'Presta atención a las escalas que debes usar para responder, en ocasiones pueden variar (ej: a veces del 1 al 100 o a veces del -100 al 100, etc.). Tus resultados son estrictamente confidenciales, por tanto, rogamos que ofrezcas respuestas intuitivas y sinceras, no le des muchas vueltas, solo utiliza tu primera impresión para ofrecer tus opiniones.',
              '¡¡Importante!! Para asegurar que las personas que participan están contestando atentamente la tarea, hemos introducido algunos “test atencionales”. Durante la tarea, sin previo aviso, aparecerá un mensaje que te pedirá que selecciones un número en concreto entre el 1 y el 100, si no lo haces correctamente tus datos no podrán ser incluidos en el estudio. Muchas gracias por tu atención, ¡adelante!'
            ]
        }
    },
    {
        "blockId": "3.1-intro",
        "text": {
            "male": [
                'A continuación se te pedirá que juzgues <b>cuanto te representan</b> distintos adjetivos mediante una barra que deberás deslizar, hasta hallar el número que debes seleccionar <b>en una escala del 1 al 100</b>. En esta escala 1 representa <b>“No me representa en absoluto”</b> y 100 <b>“Me representa totalmente”</b>. Procura dar respuestas intuitivas y sinceras. Tendrás 10 segundos para colocar la barra en el número deseado y, cuando lo hayas hecho, presionar la tecla <b>INTRO</b>. Mantén la atención, recuerda que habrá algún control atencional.'
            ],
            "female": [
                'A continuación se te pedirá que juzgues <b>cuanto te representan</b> distintos adjetivos mediante una barra que deberás deslizar, hasta hallar el número que debes seleccionar <b>en una escala del 1 al 100</b>. En esta escala 1 representa <b>“No me representa en absoluto”</b> y 100 <b>“Me representa totalmente”</b>. Procura dar respuestas intuitivas y sinceras. Tendrás 10 segundos para colocar la barra en el número deseado y, cuando lo hayas hecho, presionar la tecla <b>INTRO</b>. Mantén la atención, recuerda que habrá algún control atencional.'
            ]
            }
    },
    {
      "blockId": "3.1",
      "text": {
        "male": [
            '¿Cuánto crees que te representa este adjetivo?'
        ],
        "female": [
          '¿Cuánto crees que te representa este adjetivo?'
        ]
      },
      "sliderText":{
        "max": '(Totalmente)',
        "min": '(Nada en absoluto)'
      }
    },
    {
        "blockId": "3.2-intro",
        "text": {
            "male": [
                'A continuación se te pedirá que juzgues qué opinión crees que <b>los demás participantes de la obra tienen de ti </b> respecto a distintos adjetivos mediante una barra que deberás deslizar, hasta hallar el número que debes seleccionar <b>en una escala del 1 al 100</b>. En esta escala 1 representa <b>“Dirían que este adjetivo no me representa en absoluto”</b> y 100 <b>“Dirían que este adjetivo me representa totalmente”</b>. Recuerda que, aunque quizás te sea un poco difícil, estas evaluaciones se refieren a cómo crees que te ven <b>tus compañer@s</b>. Procura dar respuestas intuitivas y sinceras. Es posible que en algún caso no estés segur@, simplemente usa tu intuición. Tendrás 10 segundos para colocar la barra en el número deseado y, cuando lo hayas hecho, presionar la tecla <b>INTRO</b>. Mantén la atención, recuerda que habrá algún control atencional.'
            ],
            "female": [
                'A continuación se te pedirá que juzgues qué opinión crees que <b>los demás participantes de la obra tienen de ti </b> respecto a distintos adjetivos mediante una barra que deberás deslizar, hasta hallar el número que debes seleccionar <b>en una escala del 1 al 100</b>. En esta escala 1 representa <b>“Dirían que este adjetivo no me representa en absoluto”</b> y 100 <b>“Dirían que este adjetivo me representa totalmente”</b>. Recuerda que, aunque quizás te sea un poco difícil, estas evaluaciones se refieren a cómo crees que te ven <b>tus compañer@s</b>. Procura dar respuestas intuitivas y sinceras. Es posible que en algún caso no estés segur@, simplemente usa tu intuición. Tendrás 10 segundos para colocar la barra en el número deseado y, cuando lo hayas hecho, presionar la tecla <b>INTRO</b>. Mantén la atención, recuerda que habrá algún control atencional.'
            ]
            }
    },
    {
        "blockId": "3.2",
        "text": {
          "male": [
            'Si las personas con las que participas en la obra tuvieran que decir cuánto te representa este adjetivo ¿Que crees que dirían?'            
          ],
          "female": [
            'Si las personas con las que participas en la obra tuvieran que decir cuánto te representa este adjetivo ¿Que crees que dirían?'
          ]
         },
         "sliderText":{
          "max": '(Dirían que me <br> representa totalmente)',
          "min": '(Dirían que no me <br> representa en absoluto)'
        }
      },
      {
        "blockId": "3.3-intro",
        "text": {
            "male": [
                'A continuación se te pedirá que juzgues como crees que un actor debería ser. Es decir, deberás ofrecer tu opinión sobre <b>qué adjetivos representan más a las características que un actor debería tener</b>. Esto podrás hacerlo mediante una barra que deberás deslizar, hasta hallar el número que debes seleccionar <b>en una escala del 1 al 100</b>. En esta escala 1 representa <b>“Un actor no debería serlo en absoluto” </b> y 100 <b>“Un actor debería serlo totalmente"</b>. Procura dar respuestas intuitivas y sinceras. Es posible que en algún caso no estés segur@, simplemente usa tu intuición. Tendrás 10 segundos para colocar la barra en el número deseado y, cuando lo hayas hecho, presionar la tecla <b>INTRO</b>. Mantén la atención, recuerda que habrá algún control atencional.'
            ],
            "female": [
                'A continuación se te pedirá que juzgues como crees que una actriz debería ser. Es decir, deberás ofrecer tu opinión sobre <b>qué adjetivos representan más a las características que una actriz debería tener</b>. Esto podrás hacerlo mediante una barra que deberás deslizar, hasta hallar el número que debes seleccionar <b>en una escala del 1 al 100</b>. En esta escala 1 representa <b>“Una actriz no debería serlo en absoluto”</b> y 100 <b>“Una actriz debería serlo totalmente”</b>. Procura dar respuestas intuitivas y sinceras. Es posible que en algún caso no estés segur@, simplemente usa tu intuición. Tendrás 10 segundos para colocar la barra en el número deseado y, cuando lo hayas hecho, presionar la tecla <b>INTRO</b>. Mantén la atención, recuerda que habrá algún control atencional.'
            ]
            }
    },
      {
        "blockId": "3.3",
        "text": {
          "male": [
            '¿Cómo crees que un actor debería ser?'
          ],
          "female": [
            '¿Cómo crees que una actriz debería ser?'
          ]
          },
          "sliderText":{
            "max": '(Debería serlo <br> totalmente)',
            "min": '(No debería serlo <br> en absoluto)'
          }
      },
      {
        "blockId": "4-intro",
        "text": {
            "male": [
                'A continuación se te pedirá que evalúes una serie de adjetivos respecto a su valencia. Es decir, deberás decidir sobre cada adjetivo si consideras que es positivo, negativo o neutral. Para hacerlo deberás elegir para cada adjetivo una puntuación del <b>-100, al 100. Donde “-100”</b> significa <b>“Totalmente negativo”</b> y “100” significa <b>“Totalmente positivo”</b>. En concreto tienes que plantearte “como de bueno es ser X adjetivo” (ej: como de Positivo o Negativo es ser competitivo, educado, egoista, etc.) EN GENERAL Encontrarás también representado el 0, para que te hagas una idea de cuál es el punto intermedio (“Totalmente neutral”). Procura dar respuestas intuitivas y sinceras. Es posible que en algún caso no estés segur@, simplemente usa tu intuición. Tendrás 10 segundos para colocar la barra en el número deseado y, cuando lo hayas hecho, presionar la tecla <b>INTRO</b>. Mantén la atención, recuerda que habrá algún control atencional.'
            ],
            "female": [
                'A continuación se te pedirá que evalúes una serie de adjetivos respecto a su valencia. Es decir, deberás decidir sobre cada adjetivo si consideras que es positivo, negativo o neutral. Para hacerlo deberás elegir para cada adjetivo una puntuación del <b>-100, al 100. Donde “-100”</b> significa <b>“Totalmente negativo”</b> y “100” significa <b>“Totalmente positivo”</b>. En concreto tienes que plantearte “como de bueno es ser X adjetivo” (ej: como de Positivo o Negativo es ser competitivo, educado, egoista, etc.) EN GENERAL  Encontrarás también representado el 0, para que te hagas una idea de cuál es el punto intermedio (“Totalmente neutral”). Procura dar respuestas intuitivas y sinceras. Es posible que en algún caso no estés segur@, simplemente usa tu intuición. Tendrás 10 segundos para colocar la barra en el número deseado y, cuando lo hayas hecho, presionar la tecla <b>INTRO</b>. Mantén la atención, recuerda que habrá algún control atencional.'
            ]
            }
    },
    {
        "blockId": "4",
        "text": {
            "male": [
                'En general, como de Positivo o Negativo consideras que es ser:'
            ],
            "female": [
              'En general, como de Positivo o Negativo consideras que es ser:'
            ]
          },
          "sliderText":{
            "max": '(Totalmente <br> positivo)',
            "min": '(Totalmente <br> negativo)'            
          }
    },
    {
      "blockId": "final",
      "text": {
          "male": [
            'La Fundación Épica la Fura dels Baus, el IDIBELL y la Universitat de Barcelona te agradecen la participación en esta investigación. ',
            'Si aún no ha concluido tu participación en este estudio, esperamos poder seguir contando contigo. Tu participación es muy importante para nosotrxs, dado que nos ayudará a comprender procesos cognitivos relevantes en nuestra investigación. ',
            'Si por lo contrario ya ha concluido, te recordamos que puedes solicitar información adicional siempre que lo necesites',
            'info@epicalab.com'
          ],
          "female": [
            'La Fundación Épica la Fura dels Baus, el IDIBELL y la Universitat de Barcelona te agradecen la participación en esta investigación. ',
            'Si aún no ha concluido tu participación en este estudio, esperamos poder seguir contando contigo. Tu participación es muy importante para nosotrxs, dado que nos ayudará a comprender procesos cognitivos relevantes en nuestra investigación. ',
            'Si por lo contrario ya ha concluido, te recordamos que puedes solicitar información adicional siempre que lo necesites.',
            'info@epicalab.com'
          ]
          }
  }
   ]

export const genders = [
    {
      "id": 1,
      "value": "Prefiero adjetivos en género gramatical femenino"
    },
    {
      "id": 2,
      "value": "Prefiero adjetivos en género gramatical masculino"
    }
   ]

export const studies = [
    {
      "id": 1,
      "value": "Primarios"
    },
    {
      "id": 2,
      "value": "Secundarios"
    },
    {
      "id": 3,
      "value": "Formación profesional o similar"
    },
    {
      "id": 4,
      "value": "Universitarios"
    },
    {
      "id": 5,
      "value": "Posgrado"
    },
    {
      "id": 6,
      "value": "Sin estudios / Otros"
    }
]

export const adjectives = [
    {
      "id": 1,
      "female": "Afectuosa",
      "male": "Afectuoso"
    },
    {
      "id": 2,
      "female": "Agradecida",
      "male": "Agradecido"
    },
    {
      "id": 3,
      "female": "Alegre",
      "male": "Alegre"
    },
    {
      "id": 4,
      "female": "Artística",
      "male": "Artístico"
    },
    {
      "id": 5,
      "female": "Aventurera",
      "male": "Aventurero"
    },
    {
      "id": 6,
      "female": "Cariñosa",
      "male": "Cariñoso"
    },
    {
      "id": 7,
      "female": "Constante",
      "male": "Constante"
    },
    {
      "id": 8,
      "female": "Convincente",
      "male": "Convincente"
    },
    {
      "id": 9,
      "female": "Cooperativa",
      "male": "Cooperativo"
    },
    {
      "id": 10,
      "female": "Cordial",
      "male": "Cordial"
    },
    {
      "id": 11,
      "female": "Culta",
      "male": "Culto"
    },
    {
      "id": 12,
      "female": "Detallista",
      "male": "Detallista"
    },
    {
      "id": 13,
      "female": "Discreta",
      "male": "Discreto"
    },
    {
      "id": 14,
      "female": "Eficiente",
      "male": "Eficiente"
    },
    {
      "id": 15,
      "female": "Empática",
      "male": "Empático"
    },
    {
      "id": 16,
      "female": "Enérgica",
      "male": "Enérgico"
    },
    {
      "id": 17,
      "female": "Selecciona el número 10",
      "male": "Selecciona el número 10"
    },
    {
      "id": 18,
      "female": "Fiel",
      "male": "Fiel"
    },
    {
      "id": 19,
      "female": "Honesta",
      "male": "Honesto"
    },
    {
      "id": 20,
      "female": "Humilde",
      "male": "Humilde"
    },
    {
      "id": 21,
      "female": "Imaginativa",
      "male": "Imaginativo"
    },
    {
      "id": 22,
      "female": "Independiente",
      "male": "Independiente"
    },
    {
      "id": 23,
      "female": "Ingeniosa",
      "male": "Ingenioso"
    },
    {
      "id": 24,
      "female": "Inspiradora",
      "male": "Inspirador"
    },
    {
      "id": 25,
      "female": "Interesante",
      "male": "Interesante"
    },
    {
      "id": 26,
      "female": "Intuitiva",
      "male": "Intuitivo"
    },
    {
      "id": 27,
      "female": "Lista",
      "male": "Listo"
    },
    {
      "id": 28,
      "female": "Meticulosa",
      "male": "Meticuloso"
    },
    {
      "id": 29,
      "female": "Modesta",
      "male": "Modesto"
    },
    {
      "id": 30,
      "female": "Original",
      "male": "Original"
    },
    {
      "id": 31,
      "female": "Pacífica",
      "male": "Pacífico"
    },
    {
      "id": 32,
      "female": "Perseverante",
      "male": "Perseverante"
    },
    {
      "id": 33,
      "female": "Práctica",
      "male": "Práctico"
    },
    {
      "id": 34,
      "female": "Realista",
      "male": "Realista"
    },
    {
      "id": 35,
      "female": "Resistente",
      "male": "Resistente"
    },
    {
      "id": 36,
      "female": "Responsable",
      "male": "Responsable"
    },
    {
      "id": 37,
      "female": "Simpática",
      "male": "Simpático"
    },
    {
      "id": 38,
      "female": "Sincera",
      "male": "Sincero"
    },
    {
      "id": 39,
      "female": "Sociable",
      "male": "Sociable"
    },
    {
      "id": 40,
      "female": "Tolerante",
      "male": "Tolerante"
    },
    {
      "id": 41,
      "female": "Valiente",
      "male": "Valiente"
    },
    {
      "id": 42,
      "female": "Ansiosa",
      "male": "Ansioso"
    },
    {
      "id": 43,
      "female": "Autoritaria",
      "male": "Autoritario"
    },
    {
      "id": 44,
      "female": "Caprichosa",
      "male": "Caprichoso"
    },
    {
      "id": 45,
      "female": "Celosa",
      "male": "Celoso"
    },
    {
      "id": 46,
      "female": "Conformista",
      "male": "Conformista"
    },
    {
      "id": 47,
      "female": "Controladora",
      "male": "Controlador"
    },
    {
      "id": 48,
      "female": "Cotilla",
      "male": "Cotilla"
    },
    {
      "id": 49,
      "female": "Crédula",
      "male": "Crédulo"
    },
    {
      "id": 50,
      "female": "Desordenada",
      "male": "Desordenado"
    },
    {
      "id": 51,
      "female": "Despistada",
      "male": "Despistado"
    },
    {
      "id": 52,
      "female": "Distante",
      "male": "Distante"
    },
    {
      "id": 53,
      "female": "Egocéntrica",
      "male": "Egocéntrico"
    },
    {
      "id": 54,
      "female": "Exagerada",
      "male": "Exagerado"
    },
    {
      "id": 55,
      "female": "Hostil",
      "male": "Hostil"
    },
    {
      "id": 56,
      "female": "Impulsiva",
      "male": "Impulsivo"
    },
    {
      "id": 57,
      "female": "Impuntual",
      "male": "Impuntual"
    },
    {
      "id": 58,
      "female": "Indecisa",
      "male": "Indeciso"
    },
    {
      "id": 59,
      "female": "Individualista",
      "male": "Individualista"
    },
    {
      "id": 60,
      "female": "Inestable",
      "male": "Inestable"
    },
    {
      "id": 61,
      "female": "Influenciable",
      "male": "Influenciable"
    },
    {
      "id": 62,
      "female": "Insegura",
      "male": "Inseguro"
    },
    {
      "id": 63,
      "female": "Irritable",
      "male": "Irritable"
    },
    {
      "id": 64,
      "female": "Maniática",
      "male": "Maniático"
    },
    {
      "id": 65,
      "female": "Materialista",
      "male": "Materialista"
    },
    {
      "id": 66,
      "female": "Nerviosa",
      "male": "Nervioso"
    },
    {
      "id": 67,
      "female": "Obsesiva",
      "male": "Obsesivo"
    },
    {
      "id": 68,
      "female": "Olvidadiza",
      "male": "Olvidadizo"
    },
    {
      "id": 69,
      "female": "Orgullosa",
      "male": "Orgulloso"
    },
    {
      "id": 70,
      "female": "Pasiva",
      "male": "Pasivo"
    },
    {
      "id": 71,
      "female": "Perezosa",
      "male": "Perezoso"
    },
    {
      "id": 72,
      "female": "Pesimista",
      "male": "Pesimista"
    },
    {
      "id": 73,
      "female": "Predecible",
      "male": "Predecible"
    },
    {
      "id": 74,
      "female": "Rígida",
      "male": "Rígido"
    },
    {
      "id": 75,
      "female": "Ruidosa",
      "male": "Ruidoso"
    },
    {
      "id": 76,
      "female": "Sarcástica",
      "male": "Sarcástico"
    },
    {
      "id": 77,
      "female": "Solitaria",
      "male": "Solitario"
    },
    {
      "id": 78,
      "female": "Superficial",
      "male": "Superficial"
    },
    {
      "id": 79,
      "female": "Temperamental",
      "male": "Temperamental"
    },
    {
      "id": 80,
      "female": "Tímida",
      "male": "Tímido"
    },
    {
      "id": 81,
      "female": "Tozuda",
      "male": "Tozudo"
    }
   ]